import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/themeFour/service.png'
import _imports_1 from '@/assets/home/game_arrow_white.png'


const _hoisted_1 = { class: "message_container" }
const _hoisted_2 = { class: "page_body" }
const _hoisted_3 = { class: "tab_title" }
const _hoisted_4 = { class: "suport_content" }
const _hoisted_5 = { class: "support_banner" }
const _hoisted_6 = { class: "support_text" }
const _hoisted_7 = { class: "title" }
const _hoisted_8 = { class: "desc" }
const _hoisted_9 = { class: "main_tab_panel" }
const _hoisted_10 = { class: "tab_title_container" }
const _hoisted_11 = { class: "tab_title" }
const _hoisted_12 = {
  key: 0,
  class: "notification_badge"
}
const _hoisted_13 = { class: "content" }
const _hoisted_14 = {
  key: 2,
  class: "no_more"
}

import { ref, watch } from 'vue'
import MessageCard from './components/messageCard.vue'
import CustomHeader from '../components/common/customHeader.vue'
import NoData from '../components/common/noData.vue'
import { MessageData } from '@/view/message/supportScript'
import ContactServicePopup from '@/view/profile/contactServicePopup.vue'
import { useUserStore } from '@/stores/user'
import noRecordImg from '@/assets/themeFour/noData4.png';
import { useRouter } from 'vue-router';
import MessageContentView from './messageContentView.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'messageView',
  props: {
    dataSet: {}
  },
  emits: ['onClickTab', 'getNextPageMsgList', 'getUnreadMsgList'],
  setup(__props: any, { emit: __emit }) {

const active = ref(0)
const mainTab = ref(0)
const router = useRouter()
const userStore = useUserStore()
const props = __props
const messageContentRef = ref()
const emits = __emit

watch(mainTab, (newVal) => {
  if (newVal === 1) {
    emits('getUnreadMsgList')
  }
})

const setNoticeTypeName = (type: number, activityName: string) => {
  const tab = props.dataSet?.tabList.find(item => item.notice_type === type)
  if (!type) return props.dataSet?.activeTab?.name || ''
  if (type == 4) {
    return activityName ? activityName : 'message.bonus'
  } else {
    return tab ? tab.name : ''
  }
}

const onClickTab = (value: any) => {
  emits('onClickTab', value)
}

const getNextPageMsgList = () => {
  emits('getNextPageMsgList')
}

const backNavigate = () => {
    router.go(-1)
}

const openMessageContent = () => {
  messageContentRef.value.open()
}

return (_ctx: any,_cache: any) => {
  const _component_van_tab = _resolveComponent("van-tab")!
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!
  const _component_van_tabs = _resolveComponent("van-tabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(CustomHeader, {
      text: _ctx.$t('message.messageCenter'),
      "is-popup-close-back-icon": true,
      onClosePopup: backNavigate,
      "bg-color": '#024A49'
    }, null, 8, ["text"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_van_tabs, {
        active: mainTab.value,
        "onUpdate:active": _cache[1] || (_cache[1] = ($event: any) => ((mainTab).value = $event)),
        shrink: true,
        border: false,
        class: "custom_theme_tabs main_tabs"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_van_tab, { name: 0 }, {
            title: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('message.support')), 1)
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _cache[2] || (_cache[2] = _createElementVNode("img", {
                    src: _imports_0,
                    class: "support_girl"
                  }, null, -1)),
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createTextVNode(_toDisplayString(_ctx.$t('message.apoioOnline')) + " ", 1),
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t('message.horas')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('message.descriptions')), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(ContactServicePopup)
              ])
            ]),
            _: 1
          }),
          (_unref(userStore).loginAccount)
            ? (_openBlock(), _createBlock(_component_van_tab, {
                key: 0,
                name: 1
              }, {
                title: _withCtx(() => [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('message.notification')), 1),
                    (_unref(userStore).unreadCount > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_unref(userStore).unreadCount), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_van_tabs, {
                    active: active.value,
                    "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => ((active).value = $event)),
                    ellipsis: false,
                    onClickTab: onClickTab,
                    class: "inner_tabs"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataSet?.tabList, (item, index) => {
                        return (_openBlock(), _createBlock(_component_van_tab, {
                          key: index,
                          title: _ctx.$t(item.name),
                          name: index
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_13, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataSet?.noticeList, (msg) => {
                                return (_openBlock(), _createBlock(MessageCard, {
                                  key: msg.id,
                                  messageData: msg,
                                  title: setNoticeTypeName(msg.type, msg.activityName),
                                  attachement: msg.attachment,
                                  onOpenMessageContent: openMessageContent
                                }, null, 8, ["messageData", "title", "attachement"]))
                              }), 128)),
                              (_ctx.dataSet?.noticeList.length == 0)
                                ? (_openBlock(), _createBlock(NoData, {
                                    key: 0,
                                    text:  _ctx.$t('common.noThreeData'),
                                    image: _unref(noRecordImg)
                                  }, null, 8, ["text", "image"]))
                                : (_ctx.dataSet?.totalMsg > _ctx.dataSet?.pageSize * _ctx.dataSet?.pageNo)
                                  ? (_openBlock(), _createBlock(_component_van_row, {
                                      key: 1,
                                      style: {"display":"flex","justify-content":"center"}
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_van_col, {
                                          span: "24",
                                          class: "arrowDown"
                                        }, {
                                          default: _withCtx(() => [
                                            _createElementVNode("img", {
                                              src: _imports_1,
                                              onClick: getNextPageMsgList
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_ctx.$t('message.noMore')), 1))
                            ])
                          ]),
                          _: 2
                        }, 1032, ["title", "name"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["active"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["active"])
    ]),
    _createVNode(MessageContentView, {
      ref_key: "messageContentRef",
      ref: messageContentRef
    }, null, 512)
  ]))
}
}

})